"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/es/object/assign");
require("core-js/es/object/entries");
require("core-js/es/array/from");
require("core-js/web/url-search-params");
require("core-js/es/promise");
require("custom-event-polyfill");
require("xcssmatrix");
var React = require("react");
var react_redux_1 = require("react-redux");
var react_intl_1 = require("react-intl");
var ReactDOM = require("react-dom");
var redux_1 = require("redux");
var redux_saga_1 = require("redux-saga");
var callAllSaga_1 = require("@/rendering/common/callAllSaga");
var getAllState_1 = require("@/utils/getAllState");
var AgentProfile_1 = require("@/pages/agentProfile/components/AgentProfile");
var RootAgentProfileReducer_1 = require("@/pages/agentProfile/reducers/RootAgentProfileReducer");
var RootAgentProfileSaga_1 = require("@/pages/agentProfile/sagas/RootAgentProfileSaga");
if (typeof window !== 'undefined') {
    var stateFromServer = window.REDUX_DATA;
    var rootView = function (store) { return (React.createElement(react_redux_1.Provider, { store: store },
        React.createElement(react_intl_1.IntlProvider, { locale: "en" },
            React.createElement(AgentProfile_1.default, null)))); };
    var sagaMiddleware = redux_saga_1.default();
    var rootStore = redux_1.createStore(RootAgentProfileReducer_1.default, redux_1.applyMiddleware(sagaMiddleware));
    window.REDUX = rootStore;
    if (stateFromServer) {
        var setAllStateSymbol = getAllState_1.getAllState(stateFromServer.page);
        rootStore.dispatch({ type: setAllStateSymbol, payload: stateFromServer });
    }
    sagaMiddleware.run(callAllSaga_1.callAllSaga(RootAgentProfileSaga_1.rootAgentProfileSagas));
    ReactDOM.render(rootView(rootStore), document.getElementById('app'));
}
